import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Divider,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Slide,
  Autocomplete,
} from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import CheckIcon from '@mui/icons-material/Check';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { InputAdornment, IconButton } from "@mui/material";
import { AddCircleOutline, CurrencyRupee } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { LocationOn } from "@mui/icons-material";

import {
  Save as SaveIcon,
  Image as ImageIcon,
  AttachFile as AttachFileIcon,
  AddPhotoAlternate as AddPhotoAlternateIcon,
} from "@mui/icons-material";
import useAxios from "../useAxios";
import axios from "axios";
const AddProduct = () => {
  const axiosData = useAxios();
  const [ideas, setIdeas] = useState([]);
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);
  const [initialCityOptions, setInitialCityOptions] = useState([]);
  const [lastInput, setLastInput] = useState("");
const [imageFile, setImageFile] = useState(null);
  const [cityOptions, setCityOptions] = useState([]);
  //initial values for input fields
  const [product, setProduct] = useState({
    name: "",
    materials_list: [],
    deliverables: [],
    shortDescription: "",
    reqFromClient: [],
    category: "",
    categoryId: "",
    ideaId: "",
    ideaName: "",
    prices: [{ city: "", amount: "" }],
    city: "",
    videoLink: "",
    image_local_url:"",
    featured: false,
    images: [],
  });
  const [categories, setCategories] = useState([]);
  //price value changing function
  const handlePriceChange = (index, field, value) => {
    const updatedPrices = [...product.prices];
    updatedPrices[index][field] = value;
    setProduct({ ...product, prices: updatedPrices });
  };
  //new field adding function for price
  const addPriceField = () => {
    setProduct({
      ...product,
      prices: [...product.prices, { city: "", amount: "" }],
    });
  };
  //remove price field function
  const removePriceField = (index) => {
    const updatedPrices = product.prices.filter((_, i) => i !== index);
    setProduct({ ...product, prices: updatedPrices });
  };
  function smartSplit(input) {
    const result = [];
    let current = "";
    let parenLevel = 0;

    for (let char of input) {
      if (char === "," && parenLevel === 0) {
        result.push(current.trim());
        current = "";
      } else {
        if (char === "(") parenLevel++;
        else if (char === ")") parenLevel--;
        current += char;
      }
    }

    if (current) result.push(current.trim());
    return result;
  }

  //handle all other input fields changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Convert comma-separated string to array
    if (["deliverables", "materials_list", "reqFromClient"].includes(name)) {
      setProduct({ ...product, [name]: smartSplit(value) });
    } else if (name === "price") {
      setProduct({
        ...product,
        price: {
          ...product.price,
          [product.city]: value,
        },
      });
    } else {
      setProduct({ ...product, [name]: type === "checkbox" ? checked : value });
    }
  };
const handleImageUpload = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onloadend = () => {
    setImageFile({
      name: file.name,
      type: file.type,
      base64: reader.result.split(",")[1], // remove data:image/... part
    });
     const fileName = file.name; 
     setProduct({ ...product, image_local_url: fileName });
  };
  reader.readAsDataURL(file);
};

 const handleAddNewCity = async(cityNew)=>{
    try{
          // const newCities = cityOptions.filter(
          //   (city) => !initialCityOptions.includes(city)
          // );
          const newvalueFormat = cityNew.charAt(0).toUpperCase() + cityNew.slice(1)
            await axiosData.put("editGeneralData/generaldata", {
              dataName: "cities",
              datasList: [...initialCityOptions, newvalueFormat],
            });
            setInitialCityOptions([...initialCityOptions, newvalueFormat]); // update local ref
            await fetchCities();
    }catch(err){
 console.error("Error adding new city", err);
    }
  }
  //Create product details and save into database
  const handleSubmit = async (e) => {
    e.preventDefault();
    const priceArray = product.prices.map(({ city, amount }) => ({
      [city]: amount,
    }));
    const statusUpdate = {};

    // priceArray.forEach((item) => {
    //   const key = Object.keys(item)[0];
    //   statusUpdate[key] = "on"; // or "on", depending on what you want to set
    // });
    cityOptions.forEach((city) => {
      statusUpdate[city] = "on";
    });
    const payload = {
      produt_name: product.name,
      productCategory: product.category,
      productCategoryID: product.categoryId,
      ideaId: product.ideaId,
      ideaName: product.ideaName,
      //shortDescription: product.shortDescription,
      deliverables: product.deliverables,
      materials_list: product.materials_list,
      reqFromClient: product.reqFromClient,
      videoLink: product.videoLink,
      price: priceArray,
      image_local_url:product.image_local_url,
      image: imageFile ,
      status: {
        ...statusUpdate,
      },
    };

    try {
      // STEP 1: Create Product
      const response = await axiosData.post("registerProductDel", payload);
      if (response.data) {
        // STEP 2: Fetch All Categories
        const categoriesRes = await axiosData.get("getAllProductCategory");
        const allCategories = categoriesRes.data.productCAtegory;
        // STEP 3: Find Selected Category
        const selectedCategory = allCategories.find(
          (cat) => cat._id === product.categoryId
        );

        if (!selectedCategory) {
          console.error("Selected category not found");
          return;
        }
        const existingProductList = selectedCategory.productList || [];

        // STEP 4: Add New Product Name to List
        const updatedProductList = [...existingProductList, product.name];
        // if (product.ideaId && product.category === "Registration Ideas") {
        //   const ideaUpdateRes = await axiosData.put("updateIdea", {
        //     ideaId: product.ideaId,
        //     productName: product.name,
        //   });
        // }
        // STEP 5: Update Category with New Product List
        const updateResponse = await axiosData.put("editProductCat", {
          _id: product.categoryId,
          name: product.category,
          productList: updatedProductList,
        });

        if (updateResponse.data) {
          // Optional: reset form
          setProduct({
            name: "",
            shortDescription: "",
            deliverables: [],
            materials_list: [],
            reqFromClient: [],
            category: "",
            categoryId: "",
            videoLink: "",
            image_local_url:"",
            prices: [{ city: "", amount: "" }],
          });
          setImageFile(null)
          // ? Show success dialog
          setSuccessDialogOpen(true);
          }
      }
    } catch (err) {
      console.error("Error adding product", err);
    }
  };
  /* Get all users list from api*/
  const fetchCategory = async () => {
    await axiosData
      .get(`getAllProductCategory`)
      .then((data) => {
        setCategories(data.data.productCAtegory);
      })
      .catch((error) => {
        console.log("Error", error);
      });
  };
  /* Get cities list from api*/
  const fetchCities = async () => {
    try {
      const data = await axiosData.get(`getGeneralDataByName/cities`);
      if (data) {
        const dataCities = data.data.generalData;
        setCityOptions(dataCities.datasList);
        setInitialCityOptions(dataCities.datasList);
      }
    } catch (err) {
      console.log("Error", err);
    }
  };
  // Get category list from database
  useEffect(() => {
    fetchCategory();
    fetchCities();
  }, []);
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Add New Product
      </Typography>
      <Paper
        component="form"
        onSubmit={handleSubmit}
        sx={{ p: 3, borderRadius: 3 }}
      >
        <Box display="flex" flexDirection="column" gap={3}>
          <TextField
            fullWidth
            label="Product Name"
            name="name"
            value={product.name}
            onChange={handleChange}
            required
          />
          <FormControl fullWidth required>
            <InputLabel>Category</InputLabel>
            <Select
              name="category"
              value={product.category}
              onChange={async (e) => {
                const selectedCategory = categories.find(
                  (cat) => cat.name === e.target.value
                );
                if (selectedCategory.name === "Registration Ideas") {
                  try {
                    const ideaRes = await axiosData.get(
                      `getIdeasByCategory/${selectedCategory._id}`
                    );
                    setIdeas(ideaRes.data.ideas);
                  } catch (err) {
                    console.error("Error fetching ideas", err);
                  }
                } else {
                  setIdeas([]);
                }
                setProduct({
                  ...product,
                  category: selectedCategory.name,
                  categoryId: selectedCategory._id,
                });
              }}
              label="Category"
              required
              MenuProps={{
                disableScrollLock: true, // ? THIS FIXES YOUR ISSUE
              }}
            >
              {categories.map((category) => (
                <MenuItem key={category._id} value={category.name}>
                  {category.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {product.category === "Registration Ideas" && (
            <FormControl fullWidth required sx={{ mt: 2 }}>
              <InputLabel>Choose Idea</InputLabel>
              <Select
                name="ideaId"
                value={product.ideaId || ""}
                onChange={(e) => {
                  const selectedIdea = ideas.find(
                    (idea) => idea._id === e.target.value
                  );
                  setProduct({
                    ...product,
                    ideaId: selectedIdea._id,
                    ideaName: selectedIdea.name,
                  });
                }}
                label="Choose Idea"
                MenuProps={{
                  disableScrollLock: true, // ? THIS FIXES YOUR ISSUE
                }}
              >
                {ideas.map((idea) => (
                  <MenuItem key={idea._id} value={idea._id}>
                    {idea.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          {/* <TextField
            fullWidth
            label="Short Description"
            name="shortDescription"
            value={product.shortDescription}
            onChange={handleChange}
            multiline
            rows={2}
            required
          /> */}
          <TextField
            fullWidth
            label="Deliverables (comma separated)"
            name="deliverables"
            value={product.deliverables.join(", ")}
            onChange={handleChange}
            required
            // multiline
            // rows={4}
          />
          <TextField
            fullWidth
            label="Materials List (comma separated)"
            name="materials_list"
            value={product.materials_list.join(", ")}
            onChange={handleChange}
            required
            // multiline
            // rows={4}
          />
          <TextField
            fullWidth
            label="Requirement from client (comma separated)"
            name="reqFromClient"
            value={product.reqFromClient.join(", ")}
            onChange={handleChange}
            required
            // multiline
            // rows={4}
          />
          {/* <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: "bold" }}>
              City-wise Pricing
            </Typography>

            {product.prices.map((priceEntry, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  gap: 2,
                  alignItems: "center",
                  mb: 2,
                  p: 2,
                  backgroundColor: "background.paper",
                  borderRadius: 1,
                  boxShadow: 1,
                }}
              >
                <TextField
                  label="City"
                  value={priceEntry.city}
                  onChange={(e) =>
                    handlePriceChange(index, "city", e.target.value)
                  }
                  required
                  fullWidth
                  size="small"
                />
                <TextField
                  label="Price"
                  type="number"
                  value={priceEntry.amount}
                  onChange={(e) =>
                    handlePriceChange(index, "amount", e.target.value)
                  }
                  required
                  fullWidth
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start"><CurrencyRupee sx={{fontSize:"15px",textAlign:"center"}}/></InputAdornment>
                    ),
                  }}
                />
                <IconButton
                  onClick={() => removePriceField(index)}
                  color="error"
                  disabled={product.prices.length === 1}
                  sx={{ ml: "auto" }}
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            ))}

            <Button
              onClick={addPriceField}
              variant="outlined"
              startIcon={<AddIcon />}
              fullWidth
              sx={{ mt: 1 }}
            >
              Add Another City
            </Button>
          </Box> */}
          <Box sx={{ mb: 1 }}>
            <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: "bold" }}>
              City-wise Pricing
            </Typography>

            {product.prices.map((priceEntry, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  gap: 2,
                  alignItems: { xs: "flex-start", sm: "center" },
                  mb: 2,
                  p: 1.5,
                  backgroundColor: "background.paper",
                  borderRadius: 1,
                  boxShadow: 1,
                }}
              >
                {/* <LocationOn color="action" sx={{ mr: 1, ml: { xs: 0, sm: 1 } }} /> */}

                <Autocomplete
                  freeSolo
                  options={cityOptions}
                  value={priceEntry.city}
                  inputValue={priceEntry.city}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      handlePriceChange(index, "city", newInputValue);
                      setLastInput(newInputValue);
                    }
                  }}
                  // onBlur={() => {
                  //   if (
                  //     lastInput &&
                  //     !cityOptions.includes(lastInput) &&
                  //     lastInput.trim() !== ""
                  //   ) {
                  //     setCityOptions((prev) => [...prev, lastInput.trim()]);
                  //   }
                  // }}
                  onChange={(event, newValue) => {
                    // if (newValue && !cityOptions.includes(newValue)) {
                    //   setCityOptions((prev) => [...prev, newValue]);
                    // }
                    handlePriceChange(index, "city", newValue || "");
                  }}
                  renderInput={(params) => {
                    const showAddIcon =
                      priceEntry.city &&
                      priceEntry.city.trim() !== "" &&
                      !cityOptions.includes(priceEntry.city.trim().charAt(0).toUpperCase() + priceEntry.city.slice(1));
                    return (
                      <Box sx={{ position: "relative", width: "100%" }}>
                        <TextField
                          {...params}
                          label="City"
                          required
                          size="small"
                          sx={{
                            width: { xs: 200, sm: 250 },
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "8px",
                              paddingRight: showAddIcon ? "60px" : "14px", // Make space for our icon
                            },
                          }}
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                              <InputAdornment position="start">
                                <LocationOn color="action" />
                              </InputAdornment>
                            ),
                          }}
                        />
                        {showAddIcon && (
                          <IconButton
                            onClick={() => {
                              const newCity = priceEntry.city.trim();
                              // if (newCity && !cityOptions.includes(newCity)) {
                              //   setCityOptions((prev) => [...prev, newCity]);
                                handleAddNewCity(newCity);
                              //}
                            }}
                            size="small"
                            sx={{
                              position: "absolute",
                              right: "8px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              zIndex: 1300,
                              backgroundColor: "white", // Background to make it visible
                              "&:hover": {
                                backgroundColor: "grey.100",
                              },
                            }}
                          >
                            <AddCircleOutline
                              color="primary"
                              fontSize="small"
                            />
                          </IconButton>
                        )}
                      </Box>
                    );
                  }}
                />
                {/* <TextField
                  label="City"
                  value={priceEntry.city}
                  onChange={(e) =>
                    handlePriceChange(index, "city", e.target.value)
                  }
                  required
                  size="small"
                  sx={{ width: 250 }}
                /> */}
                <TextField
                  label="Price"
                  value={priceEntry.amount}
                  onChange={(e) =>
                    handlePriceChange(index, "amount", e.target.value)
                  }
                  required
                  size="small"
                  sx={{ width: { xs: "100%", sm: 250 } }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CurrencyRupee
                          sx={{ fontSize: "15px", textAlign: "center" }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
                <IconButton
                  onClick={() => removePriceField(index)}
                  color="error"
                  disabled={product.prices.length === 1}
                  size="small"
                  sx={{
                    alignSelf: { xs: "flex-end", sm: "center" },
                    mt: { xs: -6, sm: 0 },
                    mr: { xs: 0.5, sm: 0 },
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
            ))}

            <Button
              onClick={addPriceField}
              variant="outlined"
              size="small"
              startIcon={<AddIcon />}
              sx={{
                mt: 1,
                px: 2,
                py: 1,
                borderStyle: "dashed",
                borderColor: "primary.main",
                "&:hover": {
                  borderStyle: "dashed",
                  backgroundColor: "action.hover",
                },
                width: { xs: "100%", sm: "auto" },
              }}
            >
              Add City Pricing
            </Button>
          </Box>
          <Box>
            <TextField
              fullWidth
              label="Video Link"
              name="videoLink"
              value={product.videoLink}
              onChange={handleChange}
              required
            />
            {/* <Typography variant="subtitle1" gutterBottom>
              Product Images
            </Typography>
            <Box display="flex" alignItems="center" gap={2}>
              <Button
                variant="outlined"
                component="label"
                startIcon={<AddPhotoAlternateIcon />}
              >
                Upload Images
                <input
                  type="file"
                  hidden
                  multiple
                  onChange={handleImageUpload}
                  accept="image/*"
                />
              </Button>
              <Typography variant="caption" color="text.secondary">
                Upload up to 5 images
              </Typography>
            </Box>
            <Box display="flex" gap={1} mt={2}>
              {product.images.length > 0 ? (
                product.images.map((img, index) => (
                  <Chip
                    key={index}
                    icon={<ImageIcon />}
                    label={`Image ${index + 1}`}
                    onDelete={() => {}}
                  />
                ))
              ) : (
                <Typography variant="caption" color="text.secondary">
                  No images uploaded yet
                </Typography>
              )}
            </Box> */}
          </Box>
          <Box >
  <Typography variant="subtitle1" gutterBottom>
    Product Images
  </Typography>
  <Typography variant="subtitle2" color="primary" gutterBottom sx={{fontSize:"12px"}}>
    Note: Upload an image under 2MB and make sure its dimensions are 492 <ClearIcon sx={{fontSize:"10px"}}/> 328 pixels.
  </Typography>
 <Box display="flex" gap={1} mt={2}>
  <Button
    variant="outlined"
    component="label"
    startIcon={<AddPhotoAlternateIcon />}
  >
    Upload Images
    <input type="file" hidden accept="image/*" onChange={handleImageUpload} />
  </Button>

  {/* Show selected images */}
 
    {imageFile && (
    <Typography sx={{ mt: 1 }}>
      Selected Image: <strong>{imageFile.name}</strong>
    </Typography>
  )}
  </Box>
</Box>
          {/* <FormControlLabel
            control={
              <Checkbox
                name="featured"
                checked={product.featured}
                onChange={handleChange}
                color="primary"
              />
            }
            label="Featured Product"
          /> */}
          {/* <Divider /> */}
          <Box display="flex" justifyContent="flex-end">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              size="large"
              startIcon={<SaveIcon />}
            >
              Save Product
            </Button>
          </Box>
        </Box>
      </Paper>
      {/* <Dialog
        open={successDialogOpen}
        onClose={() => setSuccessDialogOpen(false)}
      >
        <DialogTitle>Product Created</DialogTitle>
        <DialogContent>
          <Typography>The product was successfully created!</Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setSuccessDialogOpen(false);
              setProduct({
                name: "",
                shortDescription: "",
                deliverables: [],
                materials_list: [],
                reqFromClient: [],
                category: "",
                categoryId: "",
                videoLink: "",
                prices: [{ city: "", amount: "" }],
              });
            }}
            color="primary"
            // autoFocus
          >
            OK
          </Button>
        </DialogActions>
      </Dialog> */}
      <Dialog
  open={successDialogOpen}
  onClose={() => setSuccessDialogOpen(false)}
  PaperProps={{
    sx: {
      borderRadius: 3,
      boxShadow: '0 10px 30px rgba(220, 38, 38, 0.2)',
      border: '1px solid rgba(220, 38, 38, 0.1)',
      background: 'linear-gradient(135deg, #fef2f2 0%, #fff 100%)',
      overflow: 'hidden'
    }
  }}
>
  <DialogTitle
    sx={{
      textAlign: 'center',
      paddingTop: 3,
      paddingBottom: 1,
      fontSize: '1.5rem',
      fontWeight: '700',
      color: '#1f2937',
      background: 'transparent'
    }}
  >
    Product Created Successfully!
  </DialogTitle>

  <DialogContent sx={{ padding: 3 }}>
    <Typography
      align="center"
      sx={{
        color: '#6b7280',
        fontSize: '1rem',
        lineHeight: 1.6,
        marginBottom: 1
      }}
    >
      The product was successfully created and is now ready for use.
    </Typography>
    
    {/* Success details */}
    <Box
      sx={{
        backgroundColor: '#fef2f2',
        borderRadius: 2,
        padding: 2,
        marginTop: 2,
        border: '1px solid #fecaca'
      }}
    >
      <Typography
        variant="body2"
        align="center"
        sx={{
          color: '#b91c1c',
          fontWeight: '500',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1
        }}
      >
        <TaskAltIcon sx={{ fontSize: 18 }} />
        All details have been saved successfully
      </Typography>
    </Box>
  </DialogContent>

  <DialogActions sx={{ padding: 3, paddingTop: 1 }}>
    <Button
      onClick={() => {
        setSuccessDialogOpen(false);
        setProduct({
          name: "",
          shortDescription: "",
          deliverables: [],
          materials_list: [],
          reqFromClient: [],
          category: "",
          categoryId: "",
          videoLink: "",
          prices: [{ city: "", amount: "" }],
        });
      }}
      variant="contained"
      sx={{
        background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
        color: 'white',
        borderRadius: 2,
        padding: '10px 24px',
        fontWeight: '600',
        fontSize: '1rem',
        textTransform: 'none',
        boxShadow: '0 4px 12px rgba(220, 38, 38, 0.3)',
        '&:hover': {
          background: 'linear-gradient(135deg, #b91c1c 0%, #991b1b 100%)',
          boxShadow: '0 6px 16px rgba(220, 38, 38, 0.4)',
          transform: 'translateY(-1px)'
        },
        '&:active': {
          transform: 'translateY(0)'
        },
        transition: 'all 0.2s ease-in-out',
        minWidth: 120
      }}
    >
      Continue
    </Button>
  </DialogActions>
</Dialog>
    </Box>
  );
};

export default AddProduct;
